import i18n from "i18next";
import type { FC } from "react";

import { PrimaryButton } from "../Buttons/components/ActionButton";

export type SearchButtonProps = {
    isDisabled: boolean;
    callback: () => void;
};

export const SearchButton: FC<SearchButtonProps> = ({ isDisabled, callback }) => {
    return (
        <PrimaryButton name="search_button" onClick={callback} disabled={isDisabled}>
            {i18n.t("button.search")}
        </PrimaryButton>
    );
};
